import Antd from 'thsc-ifind-antdv/es/index.js';
import zhCN from 'thsc-ifind-antdv/es/locale/zh_CN';
import enUS from 'thsc-ifind-antdv/es/locale/en_US';
import 'thsc-ifind-antdv/dist/antd.css';

export default {
  Antd,
  zhCN,
  enUS,
};
